/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Scope_Point_2Inputs */

const en_svc_research_scope_point_2 = /** @type {(inputs: Svc_Research_Scope_Point_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prospect and account research before sales calls`)
};

const lv_svc_research_scope_point_2 = /** @type {(inputs: Svc_Research_Scope_Point_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potenciālo klientu izpēte pirms pārdošanas sarunām`)
};

/**
* | output |
* | --- |
* | "Prospect and account research before sales calls" |
*
* @param {Svc_Research_Scope_Point_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_scope_point_2 = /** @type {((inputs?: Svc_Research_Scope_Point_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Scope_Point_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_scope_point_2(inputs)
	return en_svc_research_scope_point_2(inputs)
});